import React, { useContext } from 'react'
import { motion, AnimatePresence, AnimateSharedLayout } from 'framer-motion'
import { AppContext } from '@state/context'
import Toast from '@components/Toast'
import { scale } from 'tailwindcss/defaultTheme'

const Toasts = () => {
    const [state] = useContext(AppContext)
    const {
        toasts: { toasts },
    } = state

    return (
        <div className={'fixed bottom-8 left-8 z-50'}>
            <AnimateSharedLayout>
                <motion.div className={'flex flex-col items-start'}>
                    <AnimatePresence>
                        {toasts.map((toast) => (
                            <motion.div
                                key={toast.id}
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0 }}
                                transition={{
                                    ease: 'easeOut',
                                    duration: 0.25,
                                }}
                                layout
                            >
                                <Toast id={toast.id} error={toast.error}>
                                    {toast.message}
                                </Toast>
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </motion.div>
            </AnimateSharedLayout>
        </div>
    )
}

export default Toasts
